import VerticalProgramListWidget from "./VerticalProgramListWidget";

export default VerticalProgramListWidget;
